import { Injectable } from "@angular/core";
import { HttpService } from "src/app/http-service/http-service";
import { apiConfig } from "src/app/config/main-config";
import { appConfig } from "src/app/config/component-config";
import { HttpClient, HttpParams } from "@angular/common/http";
import { UtilService } from "../../../../../services/util.service";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CustomerService {
  private documentData = new BehaviorSubject("");
  private clientId = new BehaviorSubject("");
  private transactionData = new BehaviorSubject("");

  constructor(private http: HttpService, private httpService: HttpClient) {}

  addLifeInsurance(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.ADD_LIFE_INSURANCE,
      data
    );
  }

  getBankAccount(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.BANK_NAME_GET, data);
  }

  addGeneralInsurance(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.ADD_GENERAL_INSURANCE,
      data
    );
  }

  addOtherInsurance(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.ADD_OTHER_INSURANCE,
      data
    );
  }

  editOtherInsurance(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.EDIT_OTHER_INSURANCE,
      data
    );
  }

  deleteOtherInsurance(data) {
    return this.http.put(
      apiConfig.MAIN_URL +
        appConfig.DELETE_OTHER_INSURANCE +
        "otherInsuranceId=" +
        data,
      ""
    );
  }
  getOtherInsurance(data) {
    // const httpParams = new HttpParams().set('advisorId', data.advisorId).set('clientId', data.clientId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_OTHER_INSURANCE,
      UtilService.getHttpParam(data)
    );
  }
  deleteOtherAddonInsurance(data) {
    return this.http.put(
      apiConfig.MAIN_URL +
        appConfig.DELETE_OTHER_ADDON +
        "otherInsuranceAddOnId=" +
        data,
      ""
    );
  }
  deleteNomineeonInsurance(data) {
    return this.http.put(
      apiConfig.MAIN_URL +
        appConfig.DELETE_OTHER_NOMINEE +
        "otherInsuranceNomineeId=" +
        data,
      ""
    );
  }

  deleteOtherFeatureInsurance(data) {
    return this.http.put(
      apiConfig.MAIN_URL +
        appConfig.DELETE_OTHER_FEATURE +
        "otherInsuranceFeatureId=" +
        data,
      ""
    );
  }

  deleteOtherMemberInsurance(data) {
    return this.http.put(
      apiConfig.MAIN_URL +
        appConfig.DELETE_OTHER_MEMBER +
        "otherInsuranceMemberId=" +
        data,
      ""
    );
  }

  addFixedDeposit(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.ADD_FIXEDDEPOSIT,
      data
    );
  }

  deleteGeneralInsurance(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_GENERAL_INSURANCE,
      data
    );
  }

  deletePartPayment(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_PART_PAYMENT,
      data
    );
  }

  deleteBorrower(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.DELETE_BORROWER, data);
  }

  getLifeInsuranceData(data) {
    const httpParams = new HttpParams()
      .set("advisorId", data.advisorId)
      .set("id", data.id)
      .set("clientId", data.clientId)
      .set("insuranceSubTypeId", data.insuranceSubTypeId)
      .set("insuranceTypeId", data.insuranceTypeId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_LIFE_INSURANCE,
      httpParams
    );
  }

  getInsuranceCount(data) {
    const httpParams = new HttpParams()
      .set("advisorId", data.advisorId)
      .set("clientId", data.clientId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.INSURANCE_COUNT_GET,
      httpParams
    );
  }
  getIncome(data) {
    const httpParams = new HttpParams()
      .set("advisorId", data.advisorId)
      .set("clientId", data.clientId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_INCOME_COUNT,
      httpParams
    );
  }
  getExpense(data) {
    const httpParams = new HttpParams()
      .set("advisorId", data.advisorId)
      .set("clientId", data.clientId)
      .set("clientDob", data.clientDob)
      .set("fmDobList", data.fmDobList);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_EXPENSE_COUNT,
      httpParams
    );
  }
  getBudget(data) {
    const httpParams = new HttpParams()
      .set("advisorId", data.advisorId)
      .set("clientId", data.clientId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_BUDGET_COUNT,
      httpParams
    );
  }
  editLifeInsuranceData(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.EDIT_LIFE_INSURANCE,
      data
    );
  }

  editGeneralInsuranceData(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.EDIT_GENERAL_INSURANCE,
      data
    );
  }

  getGeneralInsuranceData(data) {
    // const httpParams = new HttpParams().set('advisorId', data.advisorId).set('id', data.id).set('clientId', data.clientId).set('insuranceSubTypeId', data.insuranceSubTypeId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_GENERAL_INSURANCE,
      UtilService.getHttpParam(data)
    );
  }

  getInsuranceGlobalData(data) {
    const httpParams = new HttpParams();
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_INSURANCE_GLOBAL_API,
      httpParams
    );
  }

  addLiability(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_LIABILITY, data);
  }

  editLiability(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_LIABILITY, data);
  }

  getLiabilty(data) {
    const httpParams = new HttpParams()
      .set("advisorId", data.advisorId)
      .set("clientId", data.clientId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_LIABILITY,
      httpParams
    );
  }

  editFixedDeposit(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.EDIT_FIXEDDEPOSIT,
      data
    );
  }

  getListOfFamilyByClient(data) {
    const httpParams = new HttpParams()
      .set("advisorId", data.advisorId)
      .set("clientId", data.clientId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_LIST_FAMILY_MEMBER,
      httpParams
    );
  }

  getFixedDeposit(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_FIXEDDEPOSIT, data);
  }

  getRecurringDeposit(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_RECURING_DEPOSIT,
      data
    );
  }

  getBonds(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_BONDS, data);
  }

  geCalculatedEmi(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.CALCULATE_EMI, {
      request: JSON.stringify(data),
    });
  }

  addRecurringDeposit(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.ADD_RECURRING_DEPOSIT,
      data
    );
  }

  addBonds(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_BOND, data);
  }

  editRecurringDeposit(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.EDIT_RECURRING_DEPOSIT,
      data
    );
  }

  editBonds(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_BONDS, data);
  }

  getSmallSavingSchemePPFData(data) {
    // const httpParams = new HttpParams().set('advisorId', data.advisorId).set('clientId', data.clientId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_ASSET_SMALL_SAVING_SCHEME_PPF,
      UtilService.getHttpParam(data)
    );
  }

  getSmallSavingSchemeNSCData(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_ASSET_SMALL_SAVING_SCHEME_NSC,
      UtilService.getHttpParam(data)
    );
  }

  getSmallSavingSchemeSSYData(data) {
    // const httpParams = new HttpParams().set('advisorId', data.advisorId).set('clientId', data.clientId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_ASSET_SMALL_SAVING_SCHEME_SSY,
      UtilService.getHttpParam(data)
    );
  }

  getSmallSavingSchemeKVPData(data) {
    // const httpParams = new HttpParams().set('advisorId', data.advisorId).set('clientId', data.clientId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_ASSET_SMALL_SAVING_SCHEME_KVP,
      UtilService.getHttpParam(data)
    );
  }

  getSmallSavingSchemeSCSSData(data) {
    // const httpParams = new HttpParams().set('advisorId', data.advisorId).set('clientId', data.clientId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_ASSET_SMALL_SAVING_SCHEME_SCSS,
      UtilService.getHttpParam(data)
    );
  }

  getSmallSavingSchemePOSAVINGData(data) {
    const httpParams = new HttpParams()
      .set("advisorId", data.advisorId)
      .set("clientId", data.clientId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_ASSET_SMALL_SAVING_SCHEME_POSAVING,
      httpParams
    );
  }

  getSmallSavingSchemePORDData(data) {
    // const httpParams = new HttpParams().set('advisorId', data.advisorId).set('clientId', data.clientId).set('requiredDate', data.requiredDate);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_ASSET_SMALL_SAVING_SCHEME_PO_RD,
      UtilService.getHttpParam(data)
    );
  }

  getSmallSavingSchemePOTDData(data) {
    // const httpParams = new HttpParams().set('advisorId', data.advisorId).set('clientId', data.clientId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_ASSET_SMALL_SAVING_SCHEME_PO_TD,
      UtilService.getHttpParam(data)
    );
  }

  getSmallSavingSchemePOMISData(data) {
    // const httpParams = new HttpParams().set('advisorId', data.advisorId).set('clientId', data.clientId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_ASSET_SMALL_SAVING_SCHEME_PO_MIS,
      UtilService.getHttpParam(data)
    );
  }

  getRealEstate(data) {
    const httpParams = new HttpParams()
      .set("advisorId", data.advisorId)
      .set("clientId", data.clientId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_REAL_ESTATE,
      httpParams
    );
  }

  getOthersAssets(data) {
    // const httpParams = new HttpParams().set('advisorId', data.advisorId).set('clientId', data.clientId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_OTHERS_ASSETS,
      UtilService.getHttpParam(data)
    );
  }

  getEPF_EPS(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_EPF_EPS, data);
  }

  addEPF_EPS(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_EPF_EPS, data);
  }

  editEPF_EPS(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_EPF_EPS, data);
  }

  deleteEPF_EPS(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.DELETE_EPF_EPS, data);
  }

  getEPF(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_EPF, data);
  }

  addEPF(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_EPF, data);
  }

  editEPF(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_EPF, data);
  }

  getNPS(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_NPS, data);
  }

  addNPS(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_NPS, data);
  }

  editNPS(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_NPS, data);
  }

  getGrauity(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_GRATUITY, data);
  }

  addGratuity(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_GRATUITY, data);
  }

  editGratuity(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_GRATUITY, data);
  }

  getSuperannuation(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_SUPERANNUATION,
      data
    );
  }

  addSuperannuation(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.ADD_SUPERANNUATION,
      data
    );
  }

  editSuperannuation(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.EDIT_SUPERANNUATION,
      data
    );
  }

  getEPS(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_EPS, data);
  }

  addEPS(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_EPS, data);
  }

  editEPS(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_EPS, data);
  }

  getGlobal() {
    const httpParams = new HttpParams();
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_GLOBAl, httpParams);
  }

  getOtherPayables(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.OTHER_PAYABLES, data);
  }

  addOtherPayables(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.ADD_OTHER_PAYABLES,
      data
    );
  }

  editOtherPayables(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.EDIT_OTHER_PAYABLES,
      data
    );
  }

  addRealEstate(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_REAL_ESTATE, data);
  }

  editRealEstate(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_REAL_ESTATE, data);
  }

  addOthersAssets(data) {
    delete data["getCoOwnerName"];
    delete data["getNomineeName"];
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.ADD_OTHERS_ASSETS,
      data
    );
  }

  editOthersAssets(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.EDIT_OTHERS_ASSETS,
      data
    );
  }

  addSovereignGoldBond(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.ADD_SOVEREIGN_GOLD_BOND,
      data
    );
  }

  getGoldBondsData(data) {
    // const httpParams = new HttpParams().set('advisorId', data.advisorId).set('clientId', data.clientId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_SOVEREIGN_GOLD_BOND,
      UtilService.getHttpParam(data)
    );
  }

  editSovereignGoldBond(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.EDIT_SOVEREIGN_GOLD_BOND,
      data
    );
  }

  getSovereignGoldBondIssuePrice() {
    return this.http.getCall(
      apiConfig.MAIN_URL + appConfig.GET_SOVEREIGN_GOLD_BOND_ISSUE_PRICE
    );
  }

  deleteSovereignGoldBondTransaction(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_SOVEREIGN_GOLD_BOND_TRANSACTION,
      data
    );
  }

  deleteSovereignGoldBond(data) {
    const httpParams = new HttpParams().set(
      "sovereignGoldId",
      data.sovereignGoldId
    );
    return this.http.putParam(
      apiConfig.MAIN_URL + appConfig.DELETE_SOVEREIGN_GOLD_BOND,
      data,
      httpParams
    );
  }

  addPPFScheme(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_PPF_SCHEME, data);
  }

  addNSCScheme(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_NSC_SCHEME, data);
  }

  addSSYScheme(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_SSY_SCHEME, data);
  }

  addSCSSScheme(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_SCSS_SCHEME, data);
  }

  addPOSAVINGScheme(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_PO_SAVING, data);
  }

  addPORDScheme(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.ADD_PO_RD_SCHEME,
      data
    );
  }

  getBankAccounts(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_BANK_ACCOUNTS,
      data
    );
  }

  addBankAccounts(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.ADD_BANK_ACCOUNTS,
      data
    );
  }

  editBankAcounts(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.EDIT_BANK_ACCOUNTS,
      data
    );
  }

  getCashInHand(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_CASH_IN_HAND, data);
  }

  addCashInHand(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.ADD_CASH_IN_HAND,
      data
    );
  }

  editCashInHand(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.EDIT_CASH_IN_HAND,
      data
    );
  }

  getGold(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_GOLD, data);
  }

  addGold(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_GOLD, data);
  }

  editGold(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_GOLD, data);
  }

  getOthers(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_OTHERS, data);
  }

  addOthers(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_OTHERS, data);
  }

  editOthers(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_OTHERS, data);
  }

  editNSCData(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_NSC_SCHEME, data);
  }

  editSSYData(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_SSY_SCHEME, data);
  }

  editSCSSData(data) {
    return (
      this, this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_SCSS_SCHEME, data)
    );
  }

  editPOSAVINGData(data) {
    return (
      this,
      this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_POSAVING_SCHEME, data)
    );
  }

  addPOMIS(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_POMIS, data);
  }

  editPOMIS(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_POMIS, data);
  }

  editPPF(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_PPF_SCHEME, data);
  }

  addKVP(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_KVP_SCHEME, data);
  }

  editKVP(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_KVP_SCHEME, data);
  }

  editPORD(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_PORD_SCHEME, data);
  }

  addPOTD(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_POTD_SCHEME, data);
  }

  editPOTD(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_POTD_SCHEME, data);
  }

  getAumGraphData(data) {
    const httpParams = new HttpParams()
      .set("advisorId", data.advisorId)
      .set("clientId", data.clientId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_AUM_GRAPH_DATA,
      httpParams
    );
  }

  getAssetCountGlobalData(data) {
    const httpParams = new HttpParams()
      .set("advisorId", data.advisorId)
      .set("clientId", data.clientId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_ASSET_COUNT_GLOBAL_DATA,
      httpParams
    );
  }

  deletePPF(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_PPF_SCHEME,
      data
    );
  }

  deleteNSC(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_NSC_SCHEME,
      data
    );
  }

  deleteSSY(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_SSY_SCHEME,
      data
    );
  }

  deleteKVP(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_KVP_SCHEME,
      data
    );
  }

  deleteSCSS(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_SCSS_SCHEME,
      data
    );
  }

  deletePOSAVING(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_POSAVING_SCHEME,
      data
    );
  }

  deletePORD(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_PORD_SCHEME,
      data
    );
  }

  deletePOTD(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_POTD_SCHEME,
      data
    );
  }

  deletePOMIS(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_POMIS_SCHEME,
      data
    );
  }

  getPolicyName(data) {
    const httpParams = new HttpParams()
      .set("policyName", data.policyName)
      .set("insuranceSubTypeId", data.insuranceSubTypeId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_POLICY_NAME,
      httpParams
    );
  }

  getCompanyNames(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.COMPANY_LIST_GET, {
      query: data,
    });
  }

  deleteInsurance(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.DELETE_INSURANCE, data);
  }

  getInsuranceData(data) {
    // const httpParams = new HttpParams().set('advisorId', data.advisorId).set('clientId', data.clientId).set('insuranceTypeId', data.insuranceTypeId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_GLOBAL_INSURANCE,
      UtilService.getHttpParam(data)
    );
  }

  deleteRealEstate(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_REAL_ESTATE,
      data
    );
  }

  deleteOtherAssets(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_OTHERS_ASSETS,
      data
    );
  }

  deleteOtherPayables(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_OTHER_PAYABLES,
      data
    );
  }

  deleteLiabilities(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_LIABILITIES,
      data
    );
  }

  deleteFixedDeposite(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_FIXED_DEPOSITE,
      data
    );
  }

  deleteRecurringDeposite(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_RECURRING_DEPOSITE,
      data
    );
  }

  deleteBond(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.DELETE_BOND, data);
  }

  deleteEPF(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.DELETE_EPF, data);
  }

  deleteNPS(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.DELETE_NPS, data);
  }

  deleteGratuity(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.DELETE_GRATUITY, data);
  }

  deleteSuperAnnuation(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_SUPERANNUATION,
      data
    );
  }

  deleteEPS(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.DELETE_EPS, data);
  }

  deleteBankAccount(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_BANKACCOUNT,
      data
    );
  }

  deleteCashInHand(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_CASHINHAND,
      data
    );
  }

  deleteGold(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.DELETE_GOLD, data);
  }

  deleteOther(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.DELETE_OTHERS, data);
  }

  getGlobalLiabilities(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GLOBAL_LIABILITIES,
      data
    );
  }

  getAllFiles(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_ALL_FILES, data);
  }

  downloadFile(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.DOWNLOAD_FILE, data);
  }

  deleteFile(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.DELETE_FILE, data);
  }

  moveFiles(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.MOVE_FILES, data);
  }

  moveFolder(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.MOVE_FOLDER, data);
  }

  copyFiles(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.COPY_FILES, data);
  }

  copyFolders(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.COPY_FOLDER, data);
  }

  renameFiles(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.RENAME_FILE, data);
  }

  renameFolder(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.RENAME_FOLDER, data);
  }

  sendSharebleLink(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.SEND_SHAREBLE_LINK,
      data
    );
  }

  deleteFolder(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.DELETE_FOLDER, data);
  }

  deleteFolderPermnant(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.DELETE_PERMANANT_FOLDER,
      data
    );
  }

  recovery(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.RECOVERY, data);
  }

  starFile(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.STAR_FILE, data);
  }

  viewActivityFile(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.VIEW_ACTIVITY_FILE,
      data
    );
  }

  viewActivityFolder(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.VIEW_ACTIVITY_FOLDER,
      data
    );
  }

  uploadFile(data) {
    // let httpParams=new HttpParams().set("advisorId",data.advisorId)
    // .set("clientId",data.clientId).set('folderId',data.folderId).set('fileName',data.fileName)
    return this.http.get(apiConfig.MAIN_URL + appConfig.UPLOAD_FILE, data);
  }

  fetchFileUpload(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.FETCH_FILE_UPLOAD_DATA,
      data
    );
  }

  getFileUploadDataClient(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_FILE_UPLOAD_DATA_CLIENT,
      data
    );
  }

  fetchFileClientData(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.FETCH_CLIENT_FILE_UPLOAD,
      data
    );
  }

  getCountAllDocs(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_COUNT_DOCS, data);
  }

  clientUploadFile(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.CLIENT_UPLOAD_FILE,
      data
    );
  }

  deleteClientProof(data) {
    return this.http.putEncoded(
      apiConfig.USER + appConfig.DELETE_CLIENT_UPLOAD_FILE,
      data
    );
  }

  getClientProof(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_CLIENT_PROOF, data);
  }

  saveClientUploadFile(data) {
    return this.http.postEncoded(
      apiConfig.USER + appConfig.SAVE_CLIENT_UPLOAD_FILE,
      data
    );
  }

  getClientUploadFile(data) {
    return this.http.getEncoded(
      apiConfig.MAIN_URL + appConfig.GET_CLIENT_UPLOAD_FILE,
      data,
      1
    );
  }

  newFolder(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.NEW_FOLDER, data);
  }

  getAssetStockData(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_ASSET_STOCK, data);
  }

  addAssetStocks(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_ASSET_STOCK, data);
  }

  getPortfolioList(data) {
    const httpParams = new HttpParams()
      .set("advisorId", data.advisorId)
      .set("clientId", data.clientId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_PORTFOLIO_LIST,
      data
    );
  }

  getPortfolioDataList(data) {
    const httpParams = new HttpParams()
      .set("advisorId", data.advisorId)
      .set("clientId", data.clientId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_PORTFOLIODATA_LIST,
      data
    );
  }

  getScripList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_SCRIP_lIST, data);
  }

  filterScripList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_SCRIP_FILTER, data);
  }

  addPortfolio(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_PORTFOLIO, data);
  }

  deletePortfolio(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.DELETE_PORTFOLIO, data);
  }

  deleteStockData(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.DELETE_STOCK, data);
  }

  editStockData(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.EDIT_STOCK_PORTFOLIO,
      data
    );
  }

  addScrip(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_SCRIP, data);
  }

  editScriplevelHoldingAndTransaction(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.EDIT_SCRIP_HOLDING_TRANSACTION,
      data
    );
  }

  getMutualFund(data) {
    // return this.http.get(apiConfig.MAIN_URL + appConfig.MUTUAL_FUND_GET, data);
    return this.http.get(apiConfig.MF_URL + appConfig.MUTUAL_FUND_GET, data);
  }

  getNav(data) {
    // return this.http.get(apiConfig.MAIN_URL + appConfig.GET_NAV, data);
    return this.http.get(apiConfig.MF_URL + appConfig.GET_NAV, data);
  }

  getReportWiseCalculations(data) {
    //  return this.http.post(apiConfig.MAIN_URL + appConfig.REPORT_WISE_CALCULATION + '?advisorId=' + data.advisorId + '&clientId=' + data.clientId + '&timePeriod=' + data.timePeriod + '&type=' + data.type, { report: data.request });
    return this.http.post(
      apiConfig.MF_URL +
        appConfig.REPORT_WISE_CALCULATION +
        "?advisorId=" +
        data.advisorId +
        "&clientId=" +
        data.clientId +
        "&timePeriod=" +
        data.timePeriod +
        "&type=" +
        data.type,
      { report: data.request }
    );
  }

  getMfUnrealizedTransactions(data) {
    //return this.http.post(apiConfig.MAIN_URL + appConfig.UNREALIZED_TRANSACTION_GET, data);
    return this.http.post(
      apiConfig.MF_URL + appConfig.UNREALIZED_TRANSACTION_GET,
      data
    );
  }

  getSaveFilters(data) {
    // return this.http.get(apiConfig.MAIN_URL + appConfig.SAVE_FILTERS_GET, data);
    return this.http.get(apiConfig.MF_URL + appConfig.SAVE_FILTERS_GET, data);
  }

  AddSaveFilters(data) {
    //return this.http.post(apiConfig.MAIN_URL + appConfig.SAVE_FILTERS_ADD, { reportFilterConfigModelList: data.ReportFilterConfigModel });
    return this.http.post(apiConfig.MF_URL + appConfig.SAVE_FILTERS_ADD, {
      reportFilterConfigModelList: data.ReportFilterConfigModel,
    });
  }

  getDatedReportWiseCalculations(data) {
    const obj = {
      lastDate: data.lastDate,
      report: data.reportType,
    };
    //return this.http.post(apiConfig.MAIN_URL + appConfig.GET_DATED_REPORT_WISE_CALCULATION + '?advisorId=' + data.advisorId + '&clientId=' + data.clientId, obj);
    return this.http.post(
      apiConfig.MF_URL +
        appConfig.GET_DATED_REPORT_WISE_CALCULATION +
        "?advisorId=" +
        data.advisorId +
        "&clientId=" +
        data.clientId,
      obj
    );
  }

  capitalGainGet(data) {
    //return this.http.get(apiConfig.MAIN_URL + appConfig.CAPITAL_GAIN_GET, data);
    return this.http.get(apiConfig.MF_URL + appConfig.CAPITAL_GAIN_GET, data);
  }

  getMfFolioMaster(data) {
    // return this.http.get(apiConfig.MAIN_URL + appConfig.FOLIO_MASTER_DETAILS, data);
    return this.http.get(
      apiConfig.MF_URL + appConfig.FOLIO_MASTER_DETAILS,
      data
    );
  }

  getBankDetails(data) {
    return this.http.get(apiConfig.USER + appConfig.GET_BANK_DETAILS, data);
  }

  getMfSipDetails(data) {
    //return this.http.get(apiConfig.MAIN_URL + appConfig.SIP_DETAILS, data);
    return this.http.get(apiConfig.MF_URL + appConfig.SIP_DETAILS, data);
  }

  searchFile(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.SEARCH_FILE, data);
  }

  getAdviceFd(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADVICE_ADD_FD, data);
  }

  getAdviceRd(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADVICE_ADD_RD, data);
  }

  getAdvicePpf(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADVICE_ADD_PPF, data);
  }

  getAdviceNsc(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADVICE_ADD_NSC, data);
  }

  getAdviceSsy(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADVICE_ADD_SSY, data);
  }

  getAdviceKvp(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADVICE_ADD_KVP, data);
  }

  getAdviceScss(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADVICE_ADD_SCSS, data);
  }

  getAdvicePoSaving(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.ADVICE_ADD_POSAVING,
      data
    );
  }

  getAdvicePord(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADVICE_ADD_PORD, data);
  }

  getAdvicePotd(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADVICE_ADD_POTD, data);
  }

  getAdvicePomis(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.ADVICE_ADD_POMIS,
      data
    );
  }

  getAdviceRealEstate(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.ADVICE_ADD_REALESTATE,
      data
    );
  }

  getAdviceEpf(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADVICE_ADD_EPF, data);
  }

  getAdviceNps(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADVICE_ADD_NPS, data);
  }

  getSchemeChoice() {
    let httpParams;
    // = new HttpParams().set('clientId', data.clientId).set("advisorId", data.advisorId).set("familyMemberId", data.familyMemberId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.SCHEME_CHOICE,
      httpParams
    );
  }

  getFilterSchemeChoice(data) {
    let httpParams = new HttpParams().set("query", data.name);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.SCHEME_FILTER_CHOICE,
      httpParams
    );
  }

  getAdviceGratuity(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.ADVICE_ADD_GRATUITY,
      data
    );
  }

  getAdviceSuperannuation(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.ADVICE_ADD_SUPERANNUATION,
      data
    );
  }

  getAdviceEps(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADVICE_ADD_EPS, data);
  }

  getAdviceBankAccount(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.ADVICE_ADD_BANKACCOUNT,
      data
    );
  }

  getAdviceCashInHand(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.ADVICE_ADD_CASHINHAND,
      data
    );
  }

  getAdviceGold(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADVICE_ADD_GOLD, data);
  }

  getAdviceOthers(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.ADVICE_ADD_OTHERS,
      data
    );
  }

  getAdviceDeploymentsData(data) {
    let httpParams = new HttpParams()
      .set("clientId", data.clientId)
      .set("advisorId", data.advisorId)
      .set("familyMemberId", data.familyMemberId);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.ADVICE_GET_DEPLOYMENTS,
      httpParams
    );
  }

  generateGroupId(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.GENERATE_GROUP_ID,
      data
    );
  }

  consentBypass(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.CONSENT_BYPASS_POST,
      data
    );
  }

  getAdviceConsent(data) {
    let httpParams = new HttpParams().set("adviceUuid", data);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_ASSET_CONSENT,
      httpParams
    );
  }

  updateAssetConsent(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.UPDATE_ASSET_CONSENT,
      data
    );
  }

  sentEmailConsent(data) {
    return this.http.put(
      apiConfig.MAIN_URL + appConfig.SENT_EMAIL_CONSENT,
      data
    );
  }

  giveAdviceOnGold(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.GIVE_ADVICE_ON_GOLD,
      data
    );
  }

  giveAdviceOnPoSavings(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.GIVE_ADVICE_ON_PO_SAVING,
      data
    );
  }

  giveAdviceOnRealEstate(data) {
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.GIVE_ADVICE_ON_REAL_ESTATE,
      data
    );
  }

  addFamilyMembers(data) {
    return this.http.postEncoded(
      apiConfig.MAIN_URL + appConfig.ADD_FAMILY_MEMBER,
      data
    );
  }

  getFamilyMembers(data) {
    return this.http.getEncoded(
      apiConfig.USER + appConfig.GET_FAMILY_MEMBERS,
      data,
      1
    );
  }

  deleteFamilyMember(data) {
    return this.http.putEncoded(
      apiConfig.USER + appConfig.DELETE_FAMILY_MEMBER,
      data
    );
  }

  getAddressList(data) {
    return this.http.getEncoded(
      apiConfig.USER + appConfig.GET_ADDRESS_LIST,
      data,
      1
    );
  }

  getDematList(data) {
    return this.http.getEncoded(
      apiConfig.USER + appConfig.GET_DEMAT_LIST,
      data,
      1
    );
  }

  // getBankList(data) {
  //   return this.http.getEncoded(apiConfig.USER + appConfig.GET_BANK_LIST, data, 1)
  // }

  getBankList(data) {
    console.log("limitedBanks", data);
    return this.http.getEncoded(
      apiConfig.USER + appConfig.GET_BANK_LIST,
      data,
      1
    );
  }

  getJointBankList(data) {
    console.log("limitedBanks", data);
    return this.http.getEncoded(
      apiConfig.USER + appConfig.GET_BANK_LIST,
      data,
      1
    );
    // return this.http.getEncoded(apiConfig.USER + appConfig.GET_BANK_SINGLE_JOIN, data, 1)
  }

  getclientFamilybankList(data) {
    console.log("allbanks", data);
    return this.http.getEncoded(
      apiConfig.USER + appConfig.GET_CLIENT_FEMILY_BANK_LIST,
      data,
      1
    );
  }

  calculateTotalValues(data) {
    let httpParams = new HttpParams()
      .set("advisorId", data.advisorId)
      .set("clientId", data.clientId)
      .set("targetDate", data.targetDate);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.CALCULATE_TOTAL_VALUES,
      httpParams
    );
  }

  getSUmmaryList(data) {
    let httpParams = new HttpParams()
      .set("advisorId", data.advisorId)
      .set("clientId", data.clientId)
      .set("targetDate", data.targetDate);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_SUMMARY_LIST,
      httpParams
    );
  }

  getCashFlowList(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_CASHFLOW_LIST,
      UtilService.getHttpParam(data)
    );
  }

  getAssetAllocationSummary(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_ASSET_ALLOCATION_SUMMARY_LIST,
      UtilService.getHttpParam(data)
    );
  }

  getOutFlowValuesMonthWise(data) {
    let httpParams = new HttpParams()
      .set("advisorId", data.advisorId)
      .set("clientId", data.clientId)
      .set("targetDate", data.targetDate);
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_CASHFLOW_LIST,
      httpParams
    );
  }

  getStockFeeds() {
    return this.http.getAws(
      "https://6ewakqcsma.execute-api.us-east-1.amazonaws.com/default/stockfeed"
    );
  }

  getNiftyData() {
    return this.http.getAws(
      "https://fzwxpcsz49.execute-api.us-east-1.amazonaws.com/default/nifty500"
    );
  }

  getDeptData() {
    return this.http.getAws(
      "https://qi8t9vk6pf.execute-api.us-east-1.amazonaws.com/default/debtindexfeed"
    );
  }

  // overview - myfeed services
  getAllFeedsPortFolio(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.CALCULATE_TOTAL_VALUES,
      data
    );
  }

  getRTAFeeds(data) {
    // return this.http.get(apiConfig.MAIN_URL + appConfig.GET_FEEDS_MF_DATA, data);
    return this.http.get(apiConfig.MF_URL + appConfig.GET_FEEDS_MF_DATA, data);
  }

  getDocumentsFeed(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_DOCUMENTS_FEED,
      data
    );
  }

  getRiskProfile(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_FEED_RISK_PROFILE,
      data
    );
  }

  getGlobalRiskProfile(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_GLOBAL_RISK_PROFILE,
      data
    );
  }

  getRecentTransactions(data) {
    return this.http.getEncoded(
      apiConfig.TRANSACT + appConfig.GET_FEED_RECENT_TRANSACTIONS,
      data,
      null
    );
  }

  getCashFlowFeeds(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_CASHFLOW_FEEDS,
      data
    );
  }

  getCustomerFeedsProfile(data) {
    return this.http.getEncoded(
      apiConfig.USER + appConfig.GET_CUSTOMER_FEEDS_PROFILE,
      data,
      null
    );
  }

  getTransactionTypeData(data) {
    //return this.http.post(apiConfig.MAIN_URL + appConfig.MUTUAL_FUND_TRANSACTION_TYPE_LIST_POST, data)
    return this.http.post(
      apiConfig.MAIN_URL + appConfig.MUTUAL_FUND_TRANSACTION_TYPE_LIST_POST,
      data
    );
  }

  getTransactionTypeInMF(data) {
    //return this.http.get(apiConfig.MAIN_URL + appConfig.GET_TRANSACTION_TYPE, data)
    return this.http.get(
      apiConfig.MF_URL + appConfig.GET_TRANSACTION_TYPE,
      data
    );
  }

  postAddTransactionMutualFund(data) {
    //  return this.http.post(apiConfig.MAIN_URL + appConfig.MUTUAL_FUND_TRANSACTION_ADD, data);
    return this.http.post(
      apiConfig.MF_URL + appConfig.MUTUAL_FUND_TRANSACTION_ADD,
      data
    );
  }

  postEditTransactionMutualFund(data) {
    //return this.http.post(apiConfig.MAIN_URL + appConfig.MUTUAL_FUND_TRANSACTION_EDIT, data);
    return this.http.post(
      apiConfig.MF_URL + appConfig.MUTUAL_FUND_TRANSACTION_EDIT,
      data
    );
  }

  postDeleteTransactionMutualFund(data) {
    // return this.http.post(apiConfig.MAIN_URL + appConfig.MUTUAL_FUND_TRANSACTION_DELETE, data);
    return this.http.post(
      apiConfig.MF_URL + appConfig.MUTUAL_FUND_TRANSACTION_DELETE,
      data
    );
  }

  getFamilyMemberListByClientId(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.FAMILY_MEMBER_LIST_GET_BY_CLIENT_ID,
      data
    );
  }

  // getSchemeNameList(data) {
  //   return this.http.get(apiConfig.MAIN_URL + appConfig.MUTUAL_FUND_SCHEME_NAME_LIST_GET, data);
  // }

  getSchemeNameList(data) {
    return this.http.get(
      apiConfig.MF_URL + appConfig.MUTUAL_FUND_SCHEME_NAME_LIST_GET,
      data
    );
  }

  postMutualFundAdd(data) {
    // return this.http.post(apiConfig.MAIN_URL + appConfig.MUTUAL_FUND_ADD, data);
    return this.http.post(apiConfig.MF_URL + appConfig.MUTUAL_FUND_ADD, data);
  }

  postMutualFundEdit(data) {
    //  return this.http.post(apiConfig.MAIN_URL + appConfig.MUTUAL_FUND_EDIT, data);
    return this.http.post(apiConfig.MF_URL + appConfig.MUTUAL_FUND_EDIT, data);
  }

  postMutualFundDelete(data) {
    //  return this.http.post(apiConfig.MAIN_URL + appConfig.MUTUAL_FUND_DELETE, data);
    return this.http.post(
      apiConfig.MF_URL + appConfig.MUTUAL_FUND_DELETE,
      data
    );
  }

  updateClientProfilePic(data) {
    return this.http.putEncoded(
      apiConfig.USER + appConfig.UPDATE_CLIENT_PROFILE_PIC,
      data
    );
  }

  orderSoaMutualFund(data) {
    // return this.http.get(apiConfig.MAIN_URL + appConfig.ORDER_SOA_MUTUAL_FUND, data)
    return this.http.get(
      apiConfig.MF_URL + appConfig.ORDER_SOA_MUTUAL_FUND,
      data
    );
  }

  unmapFamilyMembers(data) {
    return this.http.postEncoded(
      apiConfig.USER + appConfig.UNMAP_FAMILY_MEMBER,
      data
    );
  }

  makeMinorToMajor(data) {
    const httpParams = new HttpParams()
      .set("familyMemberId", data.familyMemberId)
      .set("familyMemberType", data.familyMemberType);
    return this.http.putParam(
      apiConfig.USER + appConfig.CONVERT_MINOR_TO_MAJOR,
      data,
      httpParams
    );
  }

  getSubAdvisorListValues(data) {
    // return this.http.get(apiConfig.MAIN_URL + appConfig.GET_SUB_ADVISOR_LIST, data);
    return this.http.get(
      apiConfig.MF_URL + appConfig.GET_SUB_ADVISOR_LIST,
      data
    );
  }

  getClientLatestCASFileLogs(data) {
    // return this.http.get(apiConfig.MAIN_URL + appConfig.GET_CLIENT_LATEST_CAS_FILE_LOG, data);
    return this.http.get(
      apiConfig.MF_URL + appConfig.GET_CLIENT_LATEST_CAS_FILE_LOG,
      data
    );
  }

  postUploadCasFile(data) {
    // return this.httpService.post(apiConfig.MAIN_URL + appConfig.POST_MF_UPLOAD_CAS, data);
    return this.httpService.post(
      apiConfig.MF_URL + appConfig.POST_MF_UPLOAD_CAS,
      data
    );
  }

  getClientCasFileDetailData(data) {
    //  return this.http.get(apiConfig.MAIN_URL + appConfig.GET_CLIENT_CAS_FILE_DETAIL_DATA, data);
    return this.http.get(
      apiConfig.MF_URL + appConfig.GET_CLIENT_CAS_FILE_DETAIL_DATA,
      data
    );
  }

  putMapInvestor(data) {
    // return this.http.put(apiConfig.MAIN_URL + appConfig.PUT_MAP_INVESTOR_CAS, data);
    return this.http.put(
      apiConfig.MF_URL + appConfig.PUT_MAP_INVESTOR_CAS,
      data
    );
  }

  putMapTransaction(data) {
    //  return this.http.put(apiConfig.MAIN_URL + appConfig.PUT_MAP_TRANSACTION_CAS, data);
    return this.http.put(
      apiConfig.MF_URL + appConfig.PUT_MAP_TRANSACTION_CAS,
      data
    );
  }

  getStatusOfPastFileUpload(data) {
    // return this.http.get(apiConfig.MAIN_URL + appConfig.GET_STATUS_OF_CAS_FILE_UPLOAD, data);
    return this.http.get(
      apiConfig.MF_URL + appConfig.GET_STATUS_OF_CAS_FILE_UPLOAD,
      data
    );
  }

  getCasFileLogOnRefresh(data) {
    //  return this.http.get(apiConfig.MAIN_URL + appConfig.GET_CAS_FILE_LOG_ON_REFRESH, data);
    return this.http.get(
      apiConfig.MF_URL + appConfig.GET_CAS_FILE_LOG_ON_REFRESH,
      data
    );
  }

  putCasFileStatusUpdate(data) {
    //return this.http.put(apiConfig.MAIN_URL + appConfig.PUT_CAS_FILE_STATUS_UPDATE, data);
    return this.http.put(
      apiConfig.MF_URL + appConfig.PUT_CAS_FILE_STATUS_UPDATE,
      data
    );
  }

  getFamilyMemberListForCasMapping(data) {
    return this.http.get(
      apiConfig.USER + appConfig.GET_CLIENT_FAMILY_MEMBER_LIST_ASSET,
      data
    );
  }

  getFolioSchemeWiseNomineeDetails(data) {
    //return this.http.get(apiConfig.MAIN_URL + appConfig.GET_MUTUAL_FUND_NOMINEE_FOLIO_SCHEME_WISE_DATA, data);
    return this.http.get(
      apiConfig.MF_URL +
        appConfig.GET_MUTUAL_FUND_NOMINEE_FOLIO_SCHEME_WISE_DATA,
      data
    );
  }

  deleteCasFile(data) {
    // return this.http.put(apiConfig.MAIN_URL + appConfig.DELETE_CAS_FILE, data);
    return this.http.put(apiConfig.MF_URL + appConfig.DELETE_CAS_FILE, data);
  }

  getFactSheetAllocation(data) {
    //  return this.http.get(apiConfig.MAIN_URL + appConfig.MF_FACT_SHEET_ALLOCATION, data);
    return this.http.get(
      apiConfig.MF_URL + appConfig.MF_FACT_SHEET_ALLOCATION,
      data
    );
  }

  getFactSheetRiskometer(data) {
    //  return this.http.get(apiConfig.MAIN_URL + appConfig.MF_FACT_SHEET_RISKOMETER, data);
    return this.http.get(
      apiConfig.MF_URL + appConfig.MF_FACT_SHEET_RISKOMETER,
      data
    );
  }

  getFactSheetHistoricalNav(data) {
    // return this.http.get(apiConfig.MAIN_URL + appConfig.MF_FACT_SHEET_NAV, data);
    return this.http.get(apiConfig.MF_URL + appConfig.MF_FACT_SHEET_NAV, data);
  }

  getFactSheetCount(data) {
    // return this.http.get(apiConfig.MAIN_URL + appConfig.MF_FACT_SHEET_COUNT, data);
    return this.http.get(
      apiConfig.MF_URL + appConfig.MF_FACT_SHEET_COUNT,
      data
    );
  }

  getFactSheetDetails(data) {
    //return this.http.get(apiConfig.MAIN_URL + appConfig.MF_FACT_SHEET_SCHEME_DETAILS, data);
    return this.http.get(
      apiConfig.MF_URL + appConfig.MF_FACT_SHEET_SCHEME_DETAILS,
      data
    );
  }

  getFactInvRet(data) {
    //return this.http.get(apiConfig.MAIN_URL + appConfig.MF_FACT_SHEET_INV_RET, data);
    return this.http.get(
      apiConfig.MF_URL + appConfig.MF_FACT_SHEET_INV_RET,
      data
    );
  }

  getFactRatio(data) {
    //return this.http.get(apiConfig.MAIN_URL + appConfig.MF_FACT_SHEET_RATIO_GRAPH, data);
    return this.http.get(
      apiConfig.MF_URL + appConfig.MF_FACT_SHEET_RATIO_GRAPH,
      data
    );
  }

  getKycDetailsOfClient(data) {
    return this.http.get(
      apiConfig.USER + appConfig.GET_KYC_DETAILS_OF_CLIENT,
      data
    );
  }

  hideKycPopup(data) {
    return this.http.put(apiConfig.USER + appConfig.HIDE_KYC_POPUP, data);
  }

  OtherFolioDetails(data) {
    return this.http.get(apiConfig.USER + appConfig.OTHER_FOLIO_DETAILS, data);
  }

  refreshMutualFundList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.REFRESH_MF_LIST, data);
  }

  getElssTransacitonReport(data) {
    // return this.http.get(apiConfig.MAIN_URL + appConfig.MUTUAL_FUND_GET, data);
    return this.http.get(apiConfig.MF_URL + appConfig.ELSS_TRANSACTIONS, data);
  }

  getTableData(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_TABLE_DATA, data);
  }

  dataCleanUp(data) {
    return this.http.postWithRequestBase64(
      apiConfig.MAIN_URL + appConfig.DATA_CLEANUP,
      data
    );
  }

  getLogData(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_LOG_DATA, data);
  }

  updateProcessStatus(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.UPDATE_PROCESS_STATUS,
      data
    );
  }

  restoreGoal(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GOAL_BACKUP, data);
  }

  setDocumentData(value) {
    this.documentData.next(value);
  }

  getDocumentData() {
    return this.documentData.asObservable();
  }

  setClientId(value) {
    this.clientId.next(value);
  }

  getClientId() {
    return this.clientId.asObservable();
  }

  clearStorage() {
    this.setDocumentData("");
  }

  setTransactionData(value) {
    this.transactionData.next(value);
  }

  getTransactionData() {
    return this.transactionData.asObservable();
  }

  getSipReconMainTable(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_MAIN_TABLE_DATA,
      data
    );
  }

  getAvisorListSipReconMainPage(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_MAIN_TABLE_ADVISOR_LIST,
      data
    );
  }

  getSipReconActivityPageData(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_ACTIVITY_TABLE_DATA,
      data
    );
  }

  getCasesDetailData(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_CASES_DETAIL_DATA,
      data
    );
  }

  getOrderSummaryTableData(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_ORDER_SUMMARY_TABLE_DATA,
      data
    );
  }

  getAdvisorListOrderSummaryPage(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.ORDER_SUMMARY_PAGE_ADVISOR_LIST,
      data
    );
  }

  getAdvisorListActivityLogsPage(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.ORDER_ACTIVITY_LOG_ADVISOR_LIST,
      data
    );
  }

  getSelectClubAdvisorList(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.SELECT_CLUB_ADVSIOR_LIST,
      data
    );
  }

  getAumReconScheduleList(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_AUM_RECON_SCHEDULE_LIST,
      data
    );
  }

  getAumRecoAdvisorList(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_AUM_RECON_ADVISOR_LIST,
      data
    );
  }

  refreshAumReco(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.REFRESH_AUM_RECON,
      data
    );
  }

  downLoadFiles(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.DOWNLOAD_AUM_RECON,
      data
    );
  }

  opsTeamList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.OPS_TEAM, data);
  }

  exportToExcel(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.BEFORE_RECO_EXPORT_TO_EXCEL,
      data
    );
  }

  /* ------------- Empanelment Section -------------------*/

  getEmpanelmentDetails(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_EMPANELMENT_DETAILS,
      data
    );
  }

  getEmpanelmentDoc(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_EMPANELMENT_DOC,
      data
    );
  }

  getEmpanelmentSidebarDetails(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_EMPANELMENT_SIDEBAR_DETAILS,
      data
    );
  }

  /* ------------- Commissions Section -------------------*/

  getCommissionsPlans(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_COMMISSION_PLANS,
      data
    );
  }

  getCommissionMainTable(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_COMMISSION_TABLE,
      data
    );
  }

  getPlansPreview(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_COMMISSION_PLAN_PREVIEW,
      data
    );
  }

  checkPassword(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.CHECK_PASSWORD, data);
  }

  setPlans(data) {
    const encryptedData = btoa(JSON.stringify(data));
    return this.http.post(apiConfig.MAIN_URL + appConfig.SET_COMMISSION_PLANS, {
      query: encryptedData,
    });
  }

  getCommissionSummary(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_COMMISSION_SUMMARY,
      data
    );
  }

  getDetailedView(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_DETAILED_VIEW_COMMISSION,
      data
    );
  }

  getReportDownload(data) {
    return this.http.get(
      apiConfig.MAIN_URL + appConfig.GET_REPORT_DOWNLOAD_COMMISSION,
      data
    );
  }

  empanelmentFormSubmit(data) {
    return this.http.postEncoded(apiConfig.MAIN_URL + appConfig.SUBMIT_EMPANELMENT_FORM, data);
  }

  getEmpanelmentDocumentMaster(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_EMPANELMENT_DOCUMENT_MASTER, data);
  }

  s3DocUpload(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.S3_DOC_UPLOAD, data);
  }

  downloadFileEmpanelment(data) {
    return this.http.postEncodedWithRequestEncryption(apiConfig.MAIN_URL + appConfig.DOWNLOAD_FILE_EMPANELMENT, data);
  }

  empanelmentDocuments(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.SUBMIT_EMPANELMENT_DOC, data);
  }

  getEmpanelmentCompleted(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_EMPANELMENT_COMPLETED, data);
  }
}
